import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MoveInventoryDialogComponent } from './move-inventory-dialog.component';
import { InputSearchScannerModule } from 'src/app/shared/components/input-search-scanner/input-search-scanner.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from 'src/app/shared/components/dialog/dialog.module';
import { AddNoteModule } from '../../../add-note/add-note.module';
import { InventoryLocationsDropdownModule } from 'src/app/shared/components/inventory-locations-dropdown/inventory-locations-dropdown.module';
import { InputModule } from 'src/app/shared/components/input/input.module';
import { ErrorMessageModule } from 'src/app/shared/error-message/error-message.module';
import { ButtonModule } from 'src/app/shared/components/button/button.module';
import { DatepickerInputModule } from 'src/app/shared/components/datepicker-input/datepicker-input.module';
import { FormattedDateModule } from 'src/app/shared/pipes/formatted-date/formatted-date.module';
import { YesNoToggleModule } from 'src/app/shared/components/yes-no-toggle/yes-no-toggle.module';
import { BackCountNotResolvedTooltipModule } from 'src/app/shared/components/back-count-not-resolved-tooltip/back-count-not-resolved-tooltip.module';



@NgModule({
  declarations: [MoveInventoryDialogComponent],
  imports: [
    CommonModule,
    DialogModule,
    FormsModule,
    ReactiveFormsModule,
    InputSearchScannerModule,
    AddNoteModule,
    InventoryLocationsDropdownModule,
    InputModule,
    ErrorMessageModule,
    ButtonModule,
    DatepickerInputModule,
    FormattedDateModule,
    YesNoToggleModule,
    BackCountNotResolvedTooltipModule
  ],
  exports: [MoveInventoryDialogComponent]
})
export class MoveInventoryDialogModule { }
